import { baseGoerliTokens } from '@pancakeswap/tokens'

import { PoolCategory, SerializedNftPool } from '../../types'

export const livePools: any = [
  {
    sousId: 1,
    stakingToken: baseGoerliTokens.baseBuilderNft,
    earningToken: baseGoerliTokens.weth,
    contractAddress: '0xB17b545964ca30dA7d3358C7322db19cd8B64Cf0',
    poolCategory: PoolCategory.NFT,
    tokenPerSecond: '0.00023',
    version: 2,
    nftMarketLink: 'https://testnets.opensea.io/collection/base-mainnet-is-open-for-builders',
  },
  {
    sousId: 2,
    stakingToken: baseGoerliTokens.quackproNft,
    earningToken: baseGoerliTokens.quack2,
    contractAddress: '0xD848B446FAA2f48aacDe5E6ED530702De1aB0fF6',
    poolCategory: PoolCategory.NFT,
    tokenPerSecond: '8',
    version: 2,
    nftMarketLink: 'https://testnets.opensea.io/collection/quackpro-nft-collection',
  },
  {
    sousId: 3,
    stakingToken: baseGoerliTokens.deggkiesNft,
    earningToken: baseGoerliTokens.quack2,
    contractAddress: '0x23eF033D67F12cC995bb8105063962896691aC14',
    poolCategory: PoolCategory.NFT,
    tokenPerSecond: '8',
    version: 2,
    nftMarketLink: 'https://testnets.opensea.io/collection/deggkies-nft-collection',
  },
  {
    sousId: 4,
    stakingToken: baseGoerliTokens.dackieNft,
    earningToken: baseGoerliTokens.quack2,
    contractAddress: '0x1947651fe1d0fCd9703D59644689b2fD8072e731',
    poolCategory: PoolCategory.NFT,
    tokenPerSecond: '8',
    version: 2,
    nftMarketLink: 'https://testnets.opensea.io/collection/dackie-nft-collection',
  },
].map((p) => ({
  ...p,
  stakingToken: p.stakingToken.serialize,
  earningToken: p.earningToken.serialize,
}))

// known finished pools
export const finishedPools: SerializedNftPool[] = []

// @ts-ignore
export const pools: SerializedNftPool[] = [...livePools, ...finishedPools]
